declare namespace $ {

	export class $bog_builderui_field extends $mol_string {
		minimal_height( ): number
	}
	
}

//# sourceMappingURL=field.view.tree.d.ts.map